import { render, staticRenderFns } from "./ConsumptionsSubPacksPage.vue?vue&type=template&id=c4cebec0&"
import script from "./ConsumptionsSubPacksPage.vue?vue&type=script&lang=ts&"
export * from "./ConsumptionsSubPacksPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports